import axios from "axios";

export const logHistory = async (module, action, description) => {
  try {
    await axios.post("https://hrpsc.swisstekaluminium.com/api/history", {
      module,
      action,
      description,
      username: localStorage.getItem("username") || "Unknown",
      role: localStorage.getItem("role") || "user",
    });
  } catch (error) {
    console.log("History Save Error:", error);
  }
};